const UPDATE_PENDING_KEY = 'vo2_pwa_update_pending';

export function showPwaUpdateStatus() {
  try { sessionStorage.setItem(UPDATE_PENDING_KEY, '1'); } catch { /* Storage may be unavailable. */ }
  const status = document.getElementById('pwa-update-status');
  if (status) status.hidden = false;
}

export function hidePwaUpdateStatus() {
  try { sessionStorage.removeItem(UPDATE_PENDING_KEY); } catch { /* Storage may be unavailable. */ }
  const status = document.getElementById('pwa-update-status');
  if (status) status.hidden = true;
}
